import * as React from "react";
import * as JSXRuntime from "react/jsx-runtime";
import * as ReactDOM from "react-dom";
import * as ReactDOMClient from "react-dom/client";
import { factories } from "./factories.js";

// Only third-party code uses this compatibility boundary. Application modules use ESM.
const cache = new Map();
const nativeModules = new Map([
  [73164, React],
  [76861, React],
  [59984, JSXRuntime],
  [96178, JSXRuntime],
  [43185, ReactDOM],
  [62205, ReactDOM],
  [16746, ReactDOMClient],
  [73631, ReactDOMClient],
]);

export function getVendorModule(id) {
  id = Number(id);
  if (nativeModules.has(id)) return nativeModules.get(id);
  if (cache.has(id)) return cache.get(id).exports;
  if (!factories[id])
    throw new Error(`Module ${id} is not present in the homepage archive.`);
  const module = { id, loaded: false, exports: {} };
  cache.set(id, module);
  try {
    factories[id].call(module.exports, module, module.exports, getVendorModule);
    module.loaded = true;
  } catch (error) {
    cache.delete(id);
    throw error;
  }
  return module.exports;
}

export const hasOwn = (object, key) =>
  Object.prototype.hasOwnProperty.call(object, key);
function defineExports(target, getters = {}, values = {}) {
  for (const [name, get] of Object.entries(getters))
    if (!hasOwn(target, name))
      Object.defineProperty(target, name, { enumerable: true, get });
  for (const [name, value] of Object.entries(values))
    if (!hasOwn(target, name))
      Object.defineProperty(target, name, { enumerable: true, value });
}
function markModule(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
}
export function interopDefault(module) {
  const getter =
    module && module.__esModule ? () => module.default : () => module;
  defineExports(getter, { a: getter });
  return getter;
}
export function archivedNamespace(value, mode) {
  if (mode & 1) value = getVendorModule(value);
  if (
    mode & 8 ||
    (mode & 4 && value?.__esModule) ||
    (mode & 16 && typeof value?.then === "function")
  )
    return value;
  const result = Object.create(null);
  markModule(result);
  const getters = { default: () => value };
  if (mode & 2) {
    for (
      let current = value;
      current &&
      ![Object.prototype, Array.prototype, Function.prototype].includes(
        current,
      );
      current = Object.getPrototypeOf(current)
    ) {
      for (const name of Object.getOwnPropertyNames(current))
        if (name !== "default") getters[name] = () => value[name];
    }
  }
  defineExports(result, getters);
  return result;
}
export function loadArchivedChunk(id) {
  if ([2374, 1438, 4270, 3008].includes(id)) return Promise.resolve();
  return Promise.reject(
    new Error(
      `Chunk ${id} was not included in the homepage archive. Follow the original external link instead.`,
    ),
  );
}
export function loadArchivedModule(id) {
  return archivedNamespace(getVendorModule(id), 2);
}
Object.assign(getVendorModule, {
  d: defineExports,
  r: markModule,
  n: interopDefault,
  t: archivedNamespace,
  o: hasOwn,
  g: globalThis,
  p: "/",
  e: loadArchivedChunk,
  nmd: (module) => {
    module.paths = [];
    module.children ??= [];
    return module;
  },
  hmd: (module) => module,
});
